import React from "react";

function About2(props) {
  return (
    <section id="hero1" class="d-flex align-items-center">
      <div
        class="container position-relative"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <section id="about" class="about">
          <div class="container">
            <div class="row">
              <div
                class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
                data-aos="fade-right"
              >
                <h3>CORE SKILLS</h3>
                <p>
                  Web Development & Administration | IT Service Management | IT
                  Infrastructure Management Technology Planning | Information
                  Security Network Administration Incident Management | Vendor
                  Management Senior Technical Support Disaster Recovery | MIS
                  Management Resource Management Team Management.
                </p>
                <ul>
                  <li>
                    <i class="bi bi-check-circle"></i>Familiarity with multiple
                    programming Languages and database management systems.
                  </li>
                  <li>
                    <i class="bi bi-check-circle"></i>Sound knowledge of Web
                    tracking principles{" "}
                  </li>
                  <li>
                    <i class="bi bi-check-circle"></i>Good knowledge of Google
                    Analytics and Web Trends
                  </li>
                  <li>
                    <i class="bi bi-check-circle"></i>Highly experienced in Web
                    analytics and tracking cookies
                  </li>
                  <li>
                    <i class="bi bi-check-circle"></i>Ability to maintain online
                    acquisition strategies and analytics
                  </li>
                  <li>
                    <i class="bi bi-check-circle"></i>Ability to oversee
                    customer segmentation and metrics reporting
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default About2;
